import { useEffect, useState } from "react";
import { scoreColor, scoreBand } from "@/lib/constants";

export function HealthGauge({ score = 0, size = 220 }) {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setPct(score || 0), 200);
    return () => clearTimeout(t);
  }, [score]);

  const stroke = 16;
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const c = 2 * Math.PI * r;
  const arc = 0.75; // 270 degrees
  const trackDash = `${c * arc} ${c}`;
  const progOffset = c * arc * (1 - pct / 100);
  const color = scoreColor(score);

  return (
    <div className="relative inline-grid place-items-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-[135deg]">
        <circle cx={cx} cy={cx} r={r} fill="none" stroke="#e2e8f0" strokeWidth={stroke}
          strokeDasharray={trackDash} strokeLinecap="round" />
        <circle cx={cx} cy={cx} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={trackDash} strokeDashoffset={progOffset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 1.3s cubic-bezier(0.16,1,0.3,1)" }} />
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <div>
          <div className="font-heading font-bold tracking-tighter leading-none text-slate-900"
            style={{ fontSize: size * 0.28 }} data-testid="health-score-value">
            {score ?? "–"}
          </div>
          <div className="text-slate-500 text-sm font-medium -mt-1">/ 100</div>
          <div className="mt-1.5 text-xs font-semibold uppercase tracking-wider" style={{ color }}>
            {scoreBand(score)}
          </div>
        </div>
      </div>
    </div>
  );
}
